import gql from "graphql-tag";

const query = gql`
    query generateIrritants(
      $projectId: Int!
      $range: DateRangeInput!
      $criteriaKeys: [CriteriaKey!]
      $dataCollectorId: Int
      $thematics: [ThematicInput!]
      $keywords: [String!]
      $emotions: [Emotions!]
      $thematicAnalyzed: ThematicInput!
      $insight: String!
    ) {
      generateIrritants(
        projectId: $projectId
        range: $range
        criteriaKeys: $criteriaKeys
        dataCollectorId: $dataCollectorId
        thematics: $thematics
        keywords: $keywords
        emotions: $emotions
        thematicAnalyzed: $thematicAnalyzed
        insight: $insight
      ) {
        title
        subThematic
        explainSummary
        verbatims {
          text
          uuid
        }
        proportion
      }
    }
`;
export default query;
